import React from 'react';
import PropTypes from 'prop-types';
import { AlertModal, Text } from '@cashfree-intl/coherent';

const ActivationFailed = ({ closeModal, modalData }) => (
  <AlertModal
    type="danger"
    title="Failed to activate Paytm"
    onClose={closeModal}
    eventNameOnClose="Failed_To_Activate_Paytm_Close"
  >
    <Text color="bodyLight">{modalData?.message}</Text>
  </AlertModal>
);

ActivationFailed.propTypes = {
  closeModal: PropTypes.func.isRequired,
  modalData: PropTypes.object,
};

export default ActivationFailed;
